// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gn-0";